import { Driver } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Stack } from '@mui/material';
import React from 'react';

import CardWrapper from '../../CardWrapper';
import DriverDetails from './DriverDetails';

interface Props {
  data: Driver[];
  policyNumber?: string;
}

const DriversCard: React.FC<Props> = ({ data, policyNumber }: Props) => {
  return (
    <CardWrapper title="Drivers">
      <Stack spacing={{ mobile: 2, tablet: 3 }} sx={{
        width: 1
      }}>
        {data.map((item, idx) => (
          <DriverDetails
            key={`${item.firstName}-${item.lastName}--${idx}`}
            data={item}
            policyNumber={policyNumber}
          />
        ))}
      </Stack>
    </CardWrapper>
  );
};

export default DriversCard;
